import api from './api'
import Utils from './utils'
import { __STORAGE } from './enums'

// THPRT-6478: capture the Meta match signals (_fbp/_fbc + landing URL) for the
// signed-in or registering user via the attribution ingest (TMJV-1113, live in
// production). The backend is first-write-wins per user, so calling this from
// more points in the journey is safe and idempotent: it records a row only when
// the user has none yet (the returning-client gap this story closes) and no-ops
// for anyone already captured. Client IP and user agent are derived server-side;
// the browser only supplies the fields below. oncePerSession suppresses redundant
// calls across repeat app loads within a single session.
// Cleared on logout (cleanupStorage) so the next sign-in in the same tab captures
// again, e.g. a different user on a shared machine.
export const AD_ATTRIBUTION_SESSION_GUARD = 'tm_ad_attribution_captured'

export const captureAdAttribution = (opts?: { oncePerSession?: boolean }): void => {
    try {
        if (opts?.oncePerSession && sessionStorage.getItem(AD_ATTRIBUTION_SESSION_GUARD)) return
        api.trackAttribution({
            surface: 'thinkportal',
            landing_url: sessionStorage.getItem(__STORAGE.utmLink) || undefined,
            _fbp: Utils.getCookie('_fbp'),
            _fbc: Utils.getCookie('_fbc'),
        })
        if (opts?.oncePerSession) sessionStorage.setItem(AD_ATTRIBUTION_SESSION_GUARD, '1')
    } catch { /* noop */ }
}
